import Vue from 'vue'
import store from '@/store'
import lib from '@/library'
import fixedOdds from '@/library/fixedOdds'
import priceFormat from '@/library/priceFormat'
import interRelatedService from '@/library/interRelated'
import constants from './constants'
import getters from './getters'
import mutations from './mutations'

import fetchParams from './actions/fetchParams'
import actionsTeasers from './actions/teasers'
import actionsUpdate from './actions/betSlipUpdate'
import actionsBetSlipChecks from './actions/betSlipChecks'
import addMultiSelections from './actions/addMultiSelections'

let clone = function (obj) {
  return JSON.parse(JSON.stringify(obj))
}

const state = {
  activeBetSlip: false,
  enableFastBet: !true,
  betSlipState: {
    0: 'Idle',
    0.5: 'Info',
    1: 'WaitingToConfirm',
    2: 'LiveCountDown',
    3: 'Spinner',
    4: 'InProgress',
    5: 'Attempted',
    6: 'Acceptable',
    7: 'Canceled',
    8: 'TimedOut',
    9: 'Error'
  },
  inRefferal: false,
  autoAcceptSbTnC: true,
  confirmBetPlacement: false,
  showAcceptingChangesInfo: true,
  tabs: ['REGULAR', 'TEASER', 'RR'],
  tab: 'REGULAR',
  betPlacementResult: {},
  betSlipStatus: {},
  currentBetSlipState: 0,
  betslipSelections: [],
  betslipSelectionsIds: {},
  betslipSelectionIds: [],
  idfomarkets: {},
  idfoevents: {},
  markets: {},
  interRelated: {},
  stakeLimits: {
    min: {
      PerSelection: 0.1,
      PerBetType: 0.1
    },
    max: {
      PerSelection: 9999999,
      PerBetType: 9999999
    }
  },
  maxTakeOut: 0,
  slipTotalStakeMin: 0,
  slipTotalStakeMax: 0,
  slipTotalStakeMaxInPlay: 0,
  maxSno: 16,
  changeNo: 0,
  requestId: {
    allowedBetTypesAndReturns: 0,
    allowedBetTypesAndReturnsT: 0,
    updateBetSlipSelections: 0,
    allTeasers: 0,
    abtnr: {
      REGULAR: 0,
      TEASER: 0,
      RR: 0,
      teasers: {
        0: 0,
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0,
        7: 0,
        NFL: 0,
        BASKETBALL: 0,
        MIXED: 0
      }
    }
  },
  abtnrPayload: {},
  callABTnRforSingleSelection: !true,
  allowedBetTypesAndReturnsCnt: 0,
  allowedBetTypesAndReturns: clone(constants.initialABTnRperTab),
  betTypeStakes: clone(constants.initialBetTypeStakes),
  returns: clone(constants.initialReturns),
  multiSinglesStake: '',
  gettingABTnR: false,
  gettingABTnR4T: false,
  triggerUpdate: false,
  isLive: false,
  doBetSlipUpdade: false,
  updateBetSlipInt: {
    default: 60,
    live: 20
  },
  updateBetSlipScheduledIn: 0,
  timeouts: {
    updateBetSlipInt: null,
    updateLiveIdsInt: null,
    updateBetSlipStatusInt: null,
    getABTnRint: null,
    killHlite: null,
    autoDismissBetSlip: null
  },
  updateBetSlipStatusInt: 5,
  liveTrackerUpdateInt: 60,
  liveTracker: {},
  betSlipChanges: clone(constants.initialBetSlipChanges),
  clearMarkings: 0,
  timeout: null,
  inRunningDelay: 0,
  gracePeriod: 0,
  gracePeriodTimedOut: false,
  singleBetSlip: {
    selection: {}
  },
  teasers: {
    active: {
      NFL: 'T1',
      BASKETBALL: 'T1',
      MIXED: 'T1'
    },
    activeByGroup: {
      0: 'T1',
      1: 'T1',
      2: 'T1',
      3: 'T1',
      4: 'T1',
      5: 'T1',
      6: 'T1',
      7: 'T1',
      MIXED: 'T1'
    },
    T: clone(constants.initialTeasers),
    allowedBetTypesAndReturns: clone(constants.initialABTnR),
    spreads: constants.teaserSpreads,
    doUpdate: 0,
    teaserGroups: {},
    pendingGetTeaserGroups: false
  },
  mixedTeasers: true,
  teaserSports: ['NFL', 'BASKETBALL'],
  optedIn: {
    REGULAR: {},
    RR: {},
    TEASER: {}
  },
  attemptedBetSlip: {},
  handicapChanged: 0,
  dismissErrorFromSelection: 0,
  dismissErrorFromSelectionId: false,
  propsToStore: ['tab', 'betslipSelections', 'betslipSelectionsIds', 'betslipSelectionIds', 'idfomarkets', 'idfoevents', 'markets', 'optedIn', 'betTypeStakes', 'teasers', 'activeBetSlip'], // 'teasers.active', 'teasers.T'],
  closeFromParent: false,
  mobileFeedback: {
    timeOut: 2,
    stake: 10,
    autoHidePrlMsgAfter: 0
  },
  historyTab: 'none',
  historyTabs: ['', 'active', 'settled'],
  addingMiltipleSelections: {
    inProgress: false,
    allowSuspended: window.ctsautoconf && window.ctsautoconf.INJECT_SELECTIONS_FROM_3RD_PARTY ? window.ctsautoconf.INJECT_SELECTIONS_FROM_3RD_PARTY.allowSuspended : true,
    abortIfHasSuspended: window.ctsautoconf && window.ctsautoconf.INJECT_SELECTIONS_FROM_3RD_PARTY ? window.ctsautoconf.INJECT_SELECTIONS_FROM_3RD_PARTY.abortIfHasSuspended : false
  },
  allowedBetTypesAndReturnsSelectionsStr: '',
  allowedBetTypesAndReturnsSelectionsCall: {
    'REGULAR': '',
    'RR': '',
    'TEASER': {}
  },
  autoDismissBetSlip: false
}

const actions = {
  toggleBetslipSelection (context, selectionArr) {
    // console.log('toggleBetslipSelection action')
    var selection = selectionArr[0]
    const id = parseFloat(selection.idfoselection)
    //
    if (context.state.currentBetSlipState >= 1) {
      // console.log('BetSlip can not be changed currently')
      // alert('BetSlip can not be changed currently')
      /*
      store.dispatch('overlayState/activateBetslipMsg', ['NOT_IDLE'])
      return
      */
      var autoDismissInCase = {
        0: false,
        1: false,
        2: true,
        3: false,
        4: false
      }
      if (context.state.currentBetSlipState === 5 && autoDismissInCase[context.state.betPlacementResult.result.Status.State]) {
        context.commit('setAutoDismissBetSlip', context.state.betslipSelectionsIds[id] ? 1 : true)
        setTimeout(function () {
          context.dispatch('toggleBetslipSelection', selectionArr)
        }, 100)
      } else {
        store.dispatch('overlayState/activateBetslipMsg', ['NOT_IDLE'])
      }
      return
    }
    var preventAdding = false
    var state = context.state

    // console.log('toggleBetslipSelection')
    var asSingle = selectionArr[2]
    // console.log('toggleBetslipSelection-mutation asSingle: ' + asSingle)
    // var selection = selectionArr[0]
    var market = selectionArr[1]
    var selections
    // var interRelated

    // const id = parseFloat(selection.idfoselection)
    if (state.betslipSelectionsIds[id]) {
      // console.log('removeSelection')
      context.dispatch('unsubscribeFromMarket', selection)
      context.commit('removeSelection', selection)
      //
      if (!context.getters.selectionsNo) {
        // context.commit('clearBetSlip')
        context.dispatch('clearBetSlip')
        context.dispatch('resetBetSlipChanges')
        //
        if (context.getters.activeBetSlip === 'SingleBetSlip') {
          context.commit('setActiveBetSlip', false)
        }
      }
      context.dispatch('getTeaserGroups', selection)
      context.dispatch('getAllowedBetTypesAndReturns')
        .then(function () {
          // context.dispatch('updateBetSlip')
        })
    } else {
      // Add new selection
      context.dispatch('initBetSlipUpdate')
      if (state.betslipSelections.length >= state.maxSno) {
        preventAdding = ['MAX_NO', state.maxSno]
      }

      const m = clone(market)
      m.csvpricetypes = m.csvpricetypes ||
        (m.pricetypes && m.pricetypes[0] && m.pricetypes[0].idfopricetype) ||
        (m.pricetypes && m.pricetypes.pricetype && m.pricetypes.pricetype['#text']) ||
        m.activepricetypes
      m.csvpricetypes = m.csvpricetypes.split(',')
      //
      selection.csvpricetypes = m.csvpricetypes
      // selection.pricetype = m.csvpricetypes[0]
      selection.pricetype = fixedOdds.getdefaultPricetype(selection, context.getters.preferredPriceTypes)
      //
      m.selections = []

      var istradable = market && market.istradable && JSON.parse(market.istradable)
      if (!istradable) {
        if (!(state.addingMiltipleSelections.allowSuspended && state.addingMiltipleSelections.inProgress)) {
          // console.log('Selection is Suspended!')
          preventAdding = ['SUSPENDED']
          return
        }
      }
      if (selection.idfobolifestate && selection.idfobolifestate === 'NR') {
        // console.log('Selection idfobolifestate is ' + selection.idfobolifestate + '!')
        preventAdding = ['NR']
        return
      }
      Vue.set(state.markets, id, m)
      Vue.set(state.idfomarkets, id, m.idfomarket)
      Vue.set(state.idfoevents, id, m.idfoevent)
      Vue.set(selection, 'csvavailablebettypes', m.csvavailablebettypes ? m.csvavailablebettypes.split(',') : [])
      Vue.set(selection, 'istradable', istradable)
      Vue.set(selection, 'isclosed', false)
      if (!selection.idfosporttype) {
        Vue.set(selection, 'idfosporttype', m.idfosporttype)
      }
      Vue.set(selection, 'price', priceFormat.reCalculatePrice(selection))
      // Vue.set(state.betTypeStakes.PerSelection, id, state.betTypeStakes.S || null)

      // fixedOdds.jsonize(selection)

      selections = state.betslipSelections.slice()
      selections.push(selection)
      context.state.interRelated = interRelatedService.checkInterRelated(selections, state.markets)
      // context.state.betSlipChanges.interRelated = interRelated
      /*
      if (interRelated) {
        // console.log('This selection is interrelated)!')
        // preventAdding =  ['INTERRELATED']
      }
      */
      if (selection.pricetype && (selection.pricetype === 'CP' || selection.pricetype === 'FP') && (!selection.currentpricedown || !selection.currentpriceup)) {
        // console.log('Selection has no price!')
        preventAdding = ['NO_PRICE']
        return
      }

      if (preventAdding) {
        // alert(preventAdding[0])
        store.dispatch('overlayState/activateBetslipMsg', preventAdding)
        return
      }

      // Vue.set(state.singleBetSlip, 'selection', selection)
      //
      var isMobile = store.getters['screenState/getMobileBigAndBelow']
      var asSingleEnabled = false
      var abtnr = {}
      // var asSingleEnabled = state.enableFastBet && isMobile
      if (asSingleEnabled && (!state.betslipSelections.length || asSingle)) {
        Vue.set(selection, 'market', m)
        abtnr = {
          'PotentialReturn': selection.price,
          'TotalStake': 1,
          'UnitCount': 1,
          'CalculatedUnits': '(1)=' + selection.price + ';UnitWin(1)=' + (selection.price - 1) + ';',
          'TaxInstructions': '0|0|0|0,0|300|600|5000,0|300|600|5000',
          'TaxOnUnit': 0
        }
        Vue.set(state.allowedBetTypesAndReturns.S1.PotentialReturns.PerSelection, selection.idfoselection, abtnr)
        context.dispatch('updateSingleBetSlip', [selection]).then(function (response) {
          context.dispatch('updateStoredBetSlipSelections', response)
        })
        store.dispatch('overlayState/activateSingleBetslip').then(function (r) {
          if (r) {
            if (r === 'hide') {
              store.dispatch('overlayState/deactivateSingleBetslip')
            } else {
              Vue.set(state.singleBetSlip, 'selection', {})
              Vue.delete(state.betTypeStakes.PerSelection, selection.idfoselection)
              //
              if (store.getters['isLoggedIn'] && store.getters['getWebViewAndMobile']) {
                store.commit('overlayState/setMessageDialogMsg', {
                  reason: 'native-app',
                  persistent: true,
                  fullscreen: false
                })
                store.dispatch('overlayState/activateMessageDialog')
              } else {
                context.commit('addSelection', selection)
                //
                // context.dispatch('getTeaserOptions', selection)
                context.dispatch('getTeaserGroups', selection)
                context.dispatch('getAllowedBetTypesAndReturns')
                  .then(function () {
                    // context.dispatch('updateBetSlip')
                  })

                if (market.V) {
                  lib.WebSocketLiveService.subscribeToMarketsByIDFOMarkets([market])
                }
              }
            }
          } else {
            var idSingl = parseFloat(selection.idfoselection)
            context.commit('clearSingleBetSlip', idSingl)
            // Vue.delete(state.betslipSelectionsIds, idSingl)
            // Vue.delete(state.betTypeStakes.PerSelection, idSingl)
            // Vue.delete(state.returns.PerSelection, idSingl)
          }
        })
      } else {
        if (store.getters['isLoggedIn'] && store.getters['getWebViewAndMobile']) {
          store.commit('overlayState/setMessageDialogMsg', {reason: 'native-app', persistent: true, fullscreen: false})
          store.dispatch('overlayState/activateMessageDialog')
        } else {
          context.commit('addSelection', selection)
          //
          // context.dispatch('getTeaserOptions', selection)
          context.dispatch('getTeaserGroups', selection)
          context.dispatch('getAllowedBetTypesAndReturns')
            .then(function () {
              // context.dispatch('updateBetSlip')
            })

          if (market.V) {
            lib.WebSocketLiveService.subscribeToMarketsByIDFOMarkets([market])
          }
          //
          asSingleEnabled = state.enableFastBet
          asSingleEnabled = asSingleEnabled && isMobile
          if (asSingleEnabled) {
            if (state.betslipSelections.length === 1) {
              Vue.set(selection, 'market', m)
              Vue.set(state.singleBetSlip, 'selection', selection)
              abtnr = {
                'PotentialReturn': selection.price,
                'TotalStake': 1,
                'UnitCount': 1,
                'CalculatedUnits': '(1)=' + selection.price + ';UnitWin(1)=' + (selection.price - 1) + ';',
                'TaxInstructions': '0|0|0|0,0|300|600|5000,0|300|600|5000',
                'TaxOnUnit': 0
              }
              Vue.set(state.allowedBetTypesAndReturns.S1.PotentialReturns.PerSelection, selection.idfoselection, abtnr)
              context.dispatch('updateSingleBetSlip', [selection]).then(function (response) {
                context.dispatch('updateStoredBetSlipSelections', response)
              })
              store.dispatch('overlayState/activateSingleBetslip').then(function (r) {
                // console.log('activateSingleBetslip')
                if (r) {
                  if (r === 'hide') {
                    store.dispatch('overlayState/deactivateSingleBetslip')
                  } else {
                    Vue.set(state.singleBetSlip, 'selection', {})
                    Vue.delete(state.betTypeStakes.PerSelection, selection.idfoselection)
                    //
                    if (store.getters['isLoggedIn'] && store.getters['getWebViewAndMobile']) {
                      store.commit('overlayState/setMessageDialogMsg', {
                        reason: 'native-app',
                        persistent: true,
                        fullscreen: false
                      })
                      store.dispatch('overlayState/activateMessageDialog')
                    } else {
                      context.commit('addSelection', selection)
                      //
                      // context.dispatch('getTeaserOptions', selection)
                      context.dispatch('getTeaserGroups', selection)
                      context.dispatch('getAllowedBetTypesAndReturns')
                        .then(function () {
                          // context.dispatch('updateBetSlip')
                        })

                      if (market.V) {
                        lib.WebSocketLiveService.subscribeToMarketsByIDFOMarkets([market])
                      }
                    }
                  }
                } else {
                  var idSingl = parseFloat(selection.idfoselection)
                  context.commit('clearSingleBetSlip', idSingl)
                  // Vue.delete(state.betslipSelectionsIds, idSingl)
                  // Vue.delete(state.betTypeStakes.PerSelection, idSingl)
                  // Vue.delete(state.returns.PerSelection, idSingl)
                }
              })
            } else {
              context.commit('setActiveBetSlip', false)
              store.dispatch('overlayState/deactivateSingleBetslip')
            }
          }
        }
      }
    }
  },

  activateBetslipMsg (context, reasonsArr) {
    store.dispatch('overlayState/activateBetslipMsg', reasonsArr)
  },

  clearStakesAndReturns (context) {
    context.commit('clearStakesAndReturns')
  },

  unsubscribeFromMarket (context, selection) {
    if (selection['@type']) {
      let liveEvents = store.getters['livebettingState/liveEvents']
      let matketToUnsubscribe

      for (let i = 0; i < liveEvents.length; i++) {
        matketToUnsubscribe = liveEvents[i].markets && liveEvents[i].markets.find(mk => mk.idfomarket === selection.idfomarket)
        if (matketToUnsubscribe) {
          break
        }
      }

      if (matketToUnsubscribe && matketToUnsubscribe.V) {
        lib.WebSocketLiveService.unsubscribeFromMarkets([matketToUnsubscribe])
      }
    }
  },

  unsubscribeFromAllMarkets (context) {
    var marketsToUnsubscribe = []
    let liveEvents = store.getters['livebettingState/liveEvents']

    if (context.state.betslipSelections && context.state.betslipSelections.length > 0) {
      context.state.betslipSelections.forEach(betslipSelections => {
        liveEvents.forEach(ev => {
          let market = ev.markets && ev.markets.find(mk => mk.idfomarket === betslipSelections.idfomarket)
          if (market) {
            marketsToUnsubscribe.push(market)
          }
        })
      })

      if (marketsToUnsubscribe.length > 0) {
        lib.WebSocketLiveService.unsubscribeFromMarkets(marketsToUnsubscribe)
      }
    }
  },

  clearBetSlip (context) {
    // console.log('clearBetSlip')
    context.dispatch('unsubscribeFromAllMarkets')

    context.commit('clearBetSlip')
    context.dispatch('stopBetSlipUpdate')
    context.commit('resetAllowedBetTypesAndReturns')
    Vue.set(state, 'allowedBetTypesAndReturnsSelectionsStr', '')

    context.dispatch('resetBetSlipChanges')
    context.state.betSlipChanges.changeNo++

    store.dispatch('overlayState/deactivateSingleBetslip')
  },

  getAllowedBetTypesAndReturns (context) {
    var tab = context.state.tab
    // console.log('getAllowedBetTypesAndReturns')
    // console.log('Tab: ' + tab)
    // console.log('.requestId.abtnr: ' + context.state.requestId.abtnr)
    if (context.state.currentBetSlipState > 1) {
      return
    }
    Vue.set(context.state, 'gettingABTnR', false)
    if (tab !== 'TEASER') {
      // console.log('getAllowedBetTypesAndReturns')
      var selections = []
      // var betslipSelections = context.getters.betslipSelectionsByTab(tab)
      var betslipSelectionIds = context.getters.betslipSelectionIdsByTab(tab)
      // console.log('betslipSelectionIds: ' + betslipSelectionIds)
      // console.log('betslipSelections.length: ' + betslipSelections.length)
      for (var i = 0; i < betslipSelectionIds.length; i++) {
        // selections.push(context.getters.getSelectionById(betslipSelectionIds[i]))
        selections.push(context.getters.getSelection4AabtnrById(betslipSelectionIds[i]))
      }
      var allowedBetTypesAndReturnsSelectionsStr = ''
      if (selections.length) {
        // allowedBetTypesAndReturnsSelectionsStr = JSON.stringify(selections)
        var selectionsMappedToBetLegs = fixedOdds.getSelectionsMappedToBetLegs(selections)
        allowedBetTypesAndReturnsSelectionsStr = JSON.stringify(selectionsMappedToBetLegs)
      }
      var delta = allowedBetTypesAndReturnsSelectionsStr !== context.state.allowedBetTypesAndReturnsSelectionsCall[tab]
      if (selections.length === 1 && !context.state.callABTnRforSingleSelection) {
        Vue.set(context.state.allowedBetTypesAndReturnsSelectionsCall, tab, allowedBetTypesAndReturnsSelectionsStr)
        context.dispatch('calculateAllowedBetTypesAndReturns', selections[0])
      } else if (selections.length >= 1) {
        if (!context.state.addingMiltipleSelections.inProgress && delta) {
          // var sortedSelections = Vue._.sortBy(selections, 'idfoselection')
          // if (JSON.stringify(sortedSelections) === context.state.abtnrPayload.REGULAR) {
          //   console.log('Prevent same request ABTnR REGULAR')
          //   return
          // }
          // Vue.set(context.state.abtnrPayload, 'REGULAR', JSON.stringify(sortedSelections))
          //
          Vue.set(context.state.allowedBetTypesAndReturnsSelectionsCall, tab, allowedBetTypesAndReturnsSelectionsStr)
          Vue.set(state, 'gettingABTnR', true)
          context.state.requestId.abtnr[tab]++
          var rqId = context.state.requestId.abtnr[tab]
          return fixedOdds.getAllowedBetTypesAndReturns(selections, 'ABTnR', rqId).then(
            function (r) {
              if (rqId !== context.state.requestId.abtnr[tab]) {
                // console.log('Missmatched request getAllowedBetTypesAndReturns' + ' rqId: ' + rqId + ' <> ' + context.state.requestId.abtnr[tab] + '; ts: ' + new Date().getTime())
                return
              }
              // console.log('Set ABTnR ' + rqId + ' === ' + context.state.requestId.abtnr[tab] + '; ts: ' + new Date().getTime())
              // context.state.allowedBetTypesAndReturns[tab] = r.result
              Vue.set(context.state.allowedBetTypesAndReturns, tab, r.result)
              // context.state.allowedBetTypesAndReturnsCnt++
              Vue.set(context.state, 'gettingABTnR', false)
            }).catch(
            function (error) {
              console.log('failed to getAllowedBetTypesAndReturns rqId: ' + rqId + ' <?> ' + context.state.requestId.abtnr[tab] + '; ts: ' + new Date().getTime())
              console.log(error)
              if (rqId === context.state.requestId.abtnr[tab]) {
                Vue.set(state, 'gettingABTnR', false)
              }
            })
        }
      } else {
        // context.dispatch('clearBetSlip')
        context.commit('resetAllowedBetTypesAndReturns')
      }
    } else {
      // context.dispatch('updateTeaser')
    }
  },

  scheduleGetABTnR (context) {
    // console.log('scheduleGetABTnR')
    clearTimeout(context.state.timeouts.getABTnRint)
    context.state.timeouts.getABTnRint = setTimeout(function () {
      context.dispatch('getAllowedBetTypesAndReturns')
    }, 0)
  },

  calculateAllowedBetTypesAndReturns (context, selection) {
    // console.log('calculateAllowedBetTypesAndReturns for: ' + selection.idfoselection + ' (' + selection.price + ')')
    // console.log(selection.price)
    // console.log(selection.csvavailablebettypes)
    var tab = context.state.tab
    // console.log(state.allowedBetTypesAndReturns[tab])
    if ((selection.csvavailablebettypes.length && selection.csvavailablebettypes.indexOf('S') > -1) || !selection.csvavailablebettypes.length) {
      var data = {}
      data[selection.idfoselection] = {
        'PotentialReturn': priceFormat.reCalculatePrice(selection),
        'TotalStake': 1.0,
        'UnitCount': 1
      }
      Vue.set(context.state.allowedBetTypesAndReturns[tab].PotentialReturns, 'PerSelection', data)
      // console.log(context.state.allowedBetTypesAndReturns[tab])
    }
    Vue.set(context.state.allowedBetTypesAndReturns[tab].PotentialReturns, 'PerBetType', {})
    Vue.set(context.state.allowedBetTypesAndReturns[tab], 'AllowedBetTypes', [])
    Vue.set(context.state, 'gettingABTnR', false)
  },

  createBetSlip (context, betTypeObj) {
    console.log('VueX createBetSlip')
    var allowedBetTypesAndReturns
    var selections
    var bets = []
    var betSlip
    var teaserSports
    var t
    var sport
    //
    /*
    context.commit('killHlite')
    context.commit('clearAttemptedBetSlip')
    context.commit('setBetSlipStatus', {})
    context.commit('setBetPlacementResult', {})
    */
    //
    if (betTypeObj.tab === 'TEASER') {
      // console.log('createBetSlip TEASER')
      // teaserSports = context.state.teaserSports
      if (context.state.mixedTeasers) {
        teaserSports = ['MIXED']
      } else {
        teaserSports = context.state.teaserSports
      }
      //
      betTypeObj.pricetype = 'FP'
      for (t = 0; t < teaserSports.length; t++) {
        sport = teaserSports[t]
      // for (t in betTypeObj.selectedTeaser) {
      //   sport = t
        betTypeObj.teaserSportType = sport
        //
        allowedBetTypesAndReturns = context.state.allowedBetTypesAndReturns.TEASER[sport]
        selections = context.getters.getTeaserSelectionsBySport(betTypeObj)
        var tmp = fixedOdds.getBetsForPlacement(betTypeObj, selections, allowedBetTypesAndReturns)
        bets = bets.concat(tmp)
      }
    } else {
      allowedBetTypesAndReturns = context.state.allowedBetTypesAndReturns[context.state.tab]
      selections = context.getters.betslipSelectionsByTab(betTypeObj.tab)
      if (betTypeObj.isFastBet) {
        selections = [selections.find(function (selection) {
          return selection.idfoselection === betTypeObj.isFastBet
        })]
      }
      /*
      allowedBetTypesAndReturns = context.state.allowedBetTypesAndReturns[context.state.tab]
      selections = context.getters.betslipSelectionsByTab(context.state.tab)
      */
      // if (betTypeObj.tab === 'S1' || betTypeObj.isFastBet) {
        // selections = [context.state.singleBetSlip.selection]
        // allowedBetTypesAndReturns = context.state.allowedBetTypesAndReturns[betTypeObj.tab].PotentialReturns.PerSelection
      // }
      //
      bets = fixedOdds.getBetsForPlacement(betTypeObj, selections, allowedBetTypesAndReturns)
    }
    betSlip = {betSlip: {Bets: bets, isFastBet: !!betTypeObj.isFastBet}}
    return betSlip
  },

  placeBetSlip (context, betSlip) {
    // console.log('placeBetSlip')
    // context.commit('killHlite')
    // context.commit('setCurrentBetSlipState', 4)
    // return context.dispatch('createBetSlip', betTypeObj).then(function (betSlip) {
    /*
    if (!store.getters['isLoggedIn']) {
      return new Promise((resolve, reject) => {
        reject(new Error({exceptionType: 'isLoggedOut'}))
      })
    }
    */
    return fixedOdds.placeBetSlip(betSlip)
      .then(function (result) {
        return context.dispatch('parseBetPlacementResult', [result, betSlip.betSlip])
      })
      .catch(function (error) {
        console.log('Bet Placement Error')
        console.log(error)
        context.commit('setCurrentBetSlipState', 9)
        context.dispatch('stopCountDown')
        return error
      })
    // })
  },

  startBetSlipPlacement (context, betTypeObj) {
    // console.log('VueX startBetSlipPlacement')
    //
    context.commit('setAutoDismissBetSlip', false)
    //
    context.commit('killHlite')
    context.commit('clearAttemptedBetSlip')
    context.commit('setBetSlipStatus', {})
    context.commit('setBetPlacementResult', {})
    //
    var placeBet = function (betSlip) {
      var isLive = !false
      //
      var selections = []
      betSlip.betSlip.Bets.forEach(function (bet) {
        bet.BetLegs.forEach(function (leg) {
          if (selections.indexOf(leg.IDFOSelection) < 0) {
            /*
            if (context.getters.isSelectionLive(leg.IDFOSelection)) {
              isLive = true
            }
            */
            selections.push(leg.IDFOSelection)
          }
        })
      })
      //
      // isLive = true
      if (isLive) {
        return fixedOdds.getInRunningDelay(selections).then(
          function (delay) {
            if (delay.result) {
              betSlip.betSlip.isLive = true
              context.state.inRunningDelay = delay.result
              context.dispatch('countDown', ['inRunningDelay', null])
              context.commit('setCurrentBetSlipState', 2)
            }
            return context.dispatch('placeBetSlip', betSlip)
          })
          .catch(function (error) {
            console.log('getInRunningDelay error:')
            console.log(error)
            context.state.inRunningDelay = 0
            context.dispatch('countDown', ['inRunningDelay', null])
            context.commit('setCurrentBetSlipState', 9)
            return error
            // return context.dispatch('placeBetSlip', betSlip)
          })
          .finally(function () {
          })
      } else {
        context.commit('setCurrentBetSlipState', 4)
        return context.dispatch('placeBetSlip', betSlip)
      }
    }
    context.commit('setCurrentBetSlipState', 3)
    return context.dispatch('createBetSlip', betTypeObj).then(function (betSlip) {
      return placeBet(betSlip)
    })
  },

  parseBetPlacementResult (context, data) {
    // console.log('parseBetPlacementResult')
    var result = data[0]
    result = result || context.getters.betPlacementResult
    //
    var payload = data[1] || context.getters.attemptedBetSlip
    var isFastBet = payload.isFastBet

    var tab = context.state.tab
    var detailedStates = []
    var sportsArr = []
    var teaserBetTypes = ['T1', 'T2', 'T3']

    var selectionsCount = []
    var getSportsArr = function (bets) {
      bets.forEach(function (bet) {
        bet.BetLegs.forEach(function (leg) {
          var selection
          var id = leg.IDFOSelection
          if (selectionsCount.indexOf(id) < 0) {
            selectionsCount.push(id)
          }
          if (teaserBetTypes.indexOf(leg.IDFOPriceType) > -1) {
            id = context.getters.getSourceForTeaserSelection([leg.IDFOPriceType, id])
          }
          if (id) {
            selection = context.getters.getStoredSelectionById(id, isFastBet)
            var idfosporttype = selection.idfosporttype
            if (sportsArr.indexOf(idfosporttype) === -1) {
              sportsArr.push(idfosporttype)
            }
            //
            /*
            var market = context.getters.getStoredMarketById(id)
            getTimeToBet(market)
            */
          }
        })
      })
      return sportsArr.join(',')
    }
    /*
    var timeToFirstBet = 0
    var now = new Date().getTime()
    var getTimeToBet = function (market) {
      if (market.tsstart) {
        var d = (new Date(market.tsstart).getTime() - now) / (1000 * 1)
        if (!timeToFirstBet || d < timeToFirstBet) {
          timeToFirstBet = d
        }
      }
    }
    */

    //
    if (result.result && result.result.Status && result.result.Status.State === 2) {
      store.dispatch('getAccountDetails')
      store.dispatch('getWalletBalance')
      localStorage.setItem('lastBetTimeStamp', new Date().getTime())

      getSportsArr(result.result.Bets)

      if (isFastBet) {
        if (store.getters['screenState/getMobileBigAndBelow']) {
          store.dispatch('overlayState/activateBetslip')
        }
        store.dispatch('overlayState/deactivateSingleBetslip')
      }
    }

    //
    if (result.result && result.result.Status) {
      detailedStates = result.result.Status.DetailedState ? fixedOdds.parseBetSlipDetailedState(result.result.Status.DetailedState, result.result.TotalStake) : []
      result.result.Status.detailedStates = detailedStates
      // console.log('detailedStates:')
      // console.log(detailedStates)
      context.commit('setBetPlacementResult', result)
      context.commit('setAttemptedBetSlip', payload)
      if (detailedStates.indexOf('referred') > -1) {
        context.commit('setInRefferal', true)
      }
    }
    //
    var calculatePrice = function (selection) {
      // return parseFloat((1 + selection.currentpriceup / selection.currentpricedown).toFixed(2))
      return 1 + selection.currentpriceup / selection.currentpricedown
    }
    var updatedSelections = {}
    var updateSelections = function (selections) {
      selections.forEach(function (selection) {
        var IDFOSelection = selection.IDFOSelection
        var target
        var price
        //
        /*
        target = isFastBet ? context.state.singleBetSlip.selection : context.state.betslipSelections.find(function (s) {
          return IDFOSelection === s.idfoselection
        }) || false
        */
        target = context.state.betslipSelections.find(function (s) {
          return IDFOSelection === s.idfoselection
        }) || false
        // target = target || context.state.singleBetSlip.selection
        if (target) {
          if (target.currentpricedown.toFixed(2) !== selection.PriceDown.toFixed(2) || target.currentpriceup.toFixed(2) !== selection.PriceUp.toFixed(2)) {
            updatedSelections[IDFOSelection] = true
          }
          Vue.set(target, 'currentpricedown', selection.PriceDown)
          Vue.set(target, 'currentpriceup', selection.PriceUp)
          Vue.set(target, 'currenthandicap', selection.Handicap)
          Vue.set(target, 'lowerband', selection.LowerBand)
          Vue.set(target, 'upperband', selection.UpperBand)
          price = calculatePrice(target)
          selection.price = price
          // Vue.set(target, 'price', parseFloat(price.toFixed(2)))
          Vue.set(target, 'price', price)
        }
      })
    }

    // result = result || context.getters.betPlacementResult
    //
    context.commit('setCurrentBetSlipState', 5)
    if (result.message || result.exceptionType || (result.result && result.result.Status && result.result.Status.State === 0)) {
      context.commit('setCurrentBetSlipState', 9)
      context.commit('setInRefferal', false)
    } else {
      context.commit('setBetSlipStatus', result.result.Status)
      if (result.result && result.result.Status && result.result.Status.State === 2) {
        context.commit('setInRefferal', false)
      }
      if (result.result && result.result.Status && result.result.Status.State === 4) {
        context.commit('setInRefferal', false)
      }
      if (result.result && result.result.Status && result.result.Status.State === 5) {
        context.commit('setCurrentBetSlipState', 5)
        context.dispatch('scheduleBetSlipStatusUpdate')
      }
      if (result.result && result.result.Status && (result.result.Status.State === 1 || result.result.Status.State === 3)) {
        context.dispatch('getActualBetGracePeriod', result.result).then(
          context.commit('setCurrentBetSlipState', 6)
        ).catch(function () {
          context.commit('setCurrentBetSlipState', 6)
        })
      }

      if (result.result && result.result.Status && result.result.Status.State < 4) {
        var allowedBetTypesAndReturns = isFastBet ? context.state.allowedBetTypesAndReturns.S1 : context.state.allowedBetTypesAndReturns[tab]
        var betTypeStakes = context.state.betTypeStakes[tab]
        // recalculate BetSlip
        // console.log('Recalculate BetSlip')
        var s
        var n
        var bet
        var potentialReturn
        for (n in result.result.Bets) {
          if (tab === 'TEASER' && payload.Bets && payload.Bets[n]) {
            allowedBetTypesAndReturns = context.state.allowedBetTypesAndReturns[tab][payload.Bets[n].SportType]
            betTypeStakes = context.state.betTypeStakes[tab][payload.Bets[n].SportType]
          }
          bet = result.result.Bets[n]
          bet.IDFOBetType = bet.IDFOBetType || (payload && payload.Bets && payload.Bets[n] && payload.Bets[n].IDFOBetType)
          potentialReturn = bet.PotentialReturn / bet.WinStake
          // console.log('bet.IDFOBetType: ' + bet.IDFOBetType)
          // console.log('potentialReturn: ' + potentialReturn)
          updateSelections(bet.BetLegs)
          if (bet.IDFOBetType === 'S') {
            for (s in result.result.Bets[n].BetLegs) {
              var leg = result.result.Bets[n].BetLegs[s]
              bet.price = leg.price
              var idS = leg.IDFOSelection
              Vue.set(betTypeStakes.PerSelection, idS, bet.WinStake)
              if (allowedBetTypesAndReturns.PotentialReturns.PerSelection[idS] && updatedSelections[idS]) {
                Vue.set(allowedBetTypesAndReturns.PotentialReturns.PerSelection[idS], 'PotentialReturn', leg.price)
              }
            }
          } else {
            if (tab !== 'TEASER' && Object.keys(updatedSelections).length) {
              Vue.set(allowedBetTypesAndReturns.PotentialReturns.PerBetType[bet.IDFOBetType], 'PotentialReturn', potentialReturn)
            }
            Vue.set(betTypeStakes.PerBetType, bet.IDFOBetType, bet.WinStake)
            if (bet.IDFOBetType === 'C1') {
              Vue.set(context.state.betTypeStakes[tab].PerBetType, 'S', bet.WinStake)
            }
          }
        }
        // context.dispatch('getAllowedBetTypesAndReturns')
      }
    }
    return result
  },

  getBetSlipStatus (context, IDFOBetSlip) {
    // console.log('Vuex getBetSlipStatus: ' + IDFOBetSlip)
    return fixedOdds.getBetSlipStatus(IDFOBetSlip)
      .then(function (r) {
        return r
      })
      .catch(function (r) {
        return r
      })
  },
  getBetSlip (context, IDFOBetSlip) {
    // console.log('Vuex getBetSlipStatus: ' + IDFOBetSlip)
    return fixedOdds.getBetSlip(IDFOBetSlip)
      .then(function (r) {
        return r
      })
      .catch(function (r) {
        return r
      })
  },
  processReferredBetSlip (context, IDFOBetSlip) {
    // console.log('Vuex getBetSlipStatus: ' + IDFOBetSlip)
    return fixedOdds.processReferredBetSlip(IDFOBetSlip)
      .then(function (r) {
        return r
      })
      .catch(function (r) {
        return r
      })
  },
  getReferredBets (context, IDFOBetSlip) {
    // console.log('Vuex getBetSlipStatus: ' + IDFOBetSlip)
    return fixedOdds.getReferredBets(IDFOBetSlip)
      .then(function (r) {
        return r
      })
      .catch(function (r) {
        return r
      })
  },

  rejectBetSlip (context, toState) {
    // console.log('vuex rejectBetSlip')
    context.commit('killHlite')
    context.dispatch('stopCountDown')
    context.dispatch('resetGracePeriod')
    clearTimeout(context.state.timeouts.updateBetSlipStatusInt)
    toState = toState || 7
    context.commit('setCurrentBetSlipState', 3)

    var betSlip = context.state.betPlacementResult.result
    var status = JSON.parse(JSON.stringify(betSlip.Status))
    // delete status.detailedStates
    status.detailedStates = status.detailedStates | 64
    var data = {
      IDFOBetSlip: betSlip.IDFOBetSlip,
      betSlipStatus: status
    }

    context.commit('setInRefferal', false)
    return fixedOdds.rejectBetSlip(data.IDFOBetSlip, data.betSlipStatus)
      .then(function (result) {
        if (result.message || result.exceptionType) {
          context.commit('setCurrentBetSlipState', 9)
        } else {
          context.commit('setBetSlipStatus', {})
          context.commit('setCurrentBetSlipState', toState)
        }
      })
      .catch(function (error) {
        console.log('rejectBetSlip Error')
        console.log(error)
        context.commit('setCurrentBetSlipState', 9)
        return error
      })
  },

  confirmBetSlip (context, data) {
    // console.log('vuex confirmBetSlipUsingConfirmations')
    context.commit('killHlite')
    context.dispatch('stopCountDown')
    context.commit('setCurrentBetSlipState', 3)
    var betSlip = context.state.betPlacementResult.result
    var status = JSON.parse(JSON.stringify(betSlip.Status))
    // delete status.detailedStates
    status.detailedStates = status.detailedStates | 64
    data = data || {
      IDFOBetSlip: betSlip.IDFOBetSlip,
      betSlipStatus: status
    }

    // context.commit('setInRefferal', false)
    return fixedOdds.confirmBetSlipUsingConfirmations(data.IDFOBetSlip, data.betSlipStatus)
      .then(function (result) {
        //
        var confirmedStatus = result.result.Status
        result.result = betSlip
        result.result.Status = confirmedStatus
        //

        // var IDFOBetSlip = betSlip.IDFOBetSlip
        // context.dispatch('getBetSlip', IDFOBetSlip)

        return context.dispatch('parseBetPlacementResult', [result])
      })
      .catch(function (error) {
        console.log('confirmBetSlip Error')
        console.log(error)
        context.commit('setCurrentBetSlipState', 9)
        return error
      })
  },

  getActualBetGracePeriod (context, betSlip) {
    // console.log('vuex getActualBetGracePeriod')
    return fixedOdds.getActualBetGracePeriod(betSlip.IDFOBetSlip).then(
      function (gracePeriod) {
        context.state.gracePeriod = gracePeriod.result || 0
        context.dispatch('countDown', ['gracePeriod', betSlip])
        context.commit('setCurrentBetSlipState', 6)
      }
    ).catch(function (error) {
      console.log('getActualBetGracePeriod Error')
      console.log(error)
      context.state.gracePeriod = 0
      context.dispatch('countDown', ['gracePeriod', betSlip])
      context.commit('setCurrentBetSlipState', 6)
    })
  },

  resetGracePeriod (context) {
    context.state.gracePeriodTimedOut = false
  },

  countDown (context, data) {
    // console.log('countDown')
    var timer = data[0]
    if (context.state[timer] > 0) {
      clearTimeout(context.state.timeout)
      context.state.timeout = setTimeout(function () {
        context.state[timer]--
        context.dispatch('countDown', data)
      }, 1000)
    } else {
      clearTimeout(context.state.timeout)
      switch (timer) {
        case 'inRunningDelay':
          context.commit('setCurrentBetSlipState', 4)
          break
        case 'gracePeriod':
          // context.commit('setCurrentBetSlipState', 8)
          context.dispatch('rejectBetSlip', 8)
          context.state.gracePeriodTimedOut = true
          break
        default:
          context.commit('setCurrentBetSlipState', 5)
          break
      }
    }
  },

  stopCountDown (context) {
    clearTimeout(context.state.timeout)
  },

  scheduleBetSlipStatusUpdate (context) {
    var betSlip = context.state.betPlacementResult.result
    var IDFOBetSlip = betSlip.IDFOBetSlip
    var referredBets = []
    // console.log('IDFOBetSlip: ' + IDFOBetSlip)
    // console.log('self.updateBetSlipStatusInt: ' + context.state.updateBetSlipStatusInt)
    clearTimeout(context.state.timeouts.updateBetSlipStatusInt)
    context.state.timeouts.updateBetSlipStatusInt = setTimeout(function () {
      context.dispatch('getReferredBets', IDFOBetSlip).then(
        function (result) {
          // console.log('getReferredBets result')
          var isResolved = result && result.result && result.result.length &&
            result.result.filter(function (leg) {
              return !leg.IsResolved
            }).length === 0
          if (isResolved) {
            referredBets = result.result
            // context.dispatch('getBetSlip', IDFOBetSlip).then(
            context.dispatch('processReferredBetSlip', IDFOBetSlip).then(
              function (result) {
                // console.log(referredBets)
                if (result.result && result.result.Bets) {
                  referredBets.forEach(function (rBet) {
                    var bet = result.result.Bets.find(function (b) {
                      return b.IDFOBet === rBet.IDFOBet
                    })
                    if (bet) {
                      if (rBet.IDFOBetReferralState === 'X') {
                        bet.TotalStake = null
                        bet.WinStake = null
                      } else {
                        bet.TotalStake = rBet.ReoffWUnitStake || rBet.ReoffWUnitStakeByArc
                        bet.WinStake = rBet.ReoffWUnitStake || rBet.ReoffWUnitStakeByArc
                      }
                    }
                  })
                }
                context.dispatch('parseBetPlacementResult', [result])
              }
            )
          } else {
            context.commit('setCurrentBetSlipState', 5)
            context.dispatch('scheduleBetSlipStatusUpdate')
          }
        }
      )
    }, context.state.updateBetSlipStatusInt * 1000)
  },

  cancelBetSlipStatusUpdate (context) {
    clearTimeout(context.state.timeouts.updateBetSlipStatusInt)
  },

  saveToStorage (context, eventId) {
    // console.log('saveToStorage')
    // var storage = sessionStorage
    var storage = localStorage
    var now = new Date().getTime()
    var data = {
      ts: now,
      eventId: eventId
    }
    var props = context.state.propsToStore
    var populateData = function () {
      props.forEach(function (prop) {
        if (prop.indexOf('.') > -1) {
          var p = prop.split('.')
          data[prop] = context.state[p[0]][p[1]]
        } else {
          data[prop] = context.state[prop]
        }
      })
    }
    populateData()
    //
    // data = null
    storage.setItem('BSstate', JSON.stringify(data))
    // storage.setItem(eventId, now)
  },
  getFromStorage (context) {
    // console.log('getFromStorage')
    // var storage = sessionStorage
    var storage = localStorage
    var now = new Date().getTime()
    //
    var props = context.state.propsToStore
    var updateState = function (prop) {
      if (typeof stored[prop] !== 'undefined') {
        if (prop.indexOf('.') > -1) {
          var p = prop.split('.')
          Vue.set(context.state[p[0]], p[1], stored[prop])
        } else {
          Vue.set(context.state, prop, stored[prop])
        }
      }
    }

    var stored = !context.state.betslipSelections.length && storage.getItem('BSstate')
    storage.removeItem('BSstate')
    // console.log('stored:')
    // console.log(stored)
    stored = JSON.parse(stored)
    if (stored) {
      // alert('ev: ' + stored.eventId)
      stored.betTypeStakes.PerTab = {}
      var dt = stored && stored.ts ? (now - stored.ts) / 1000 : 999999999
      if (dt < (60 * 60 * 24)) {
        props.forEach(function (prop) {
          updateState(prop)
        })
        if (typeof stored.betTypeStakes !== 'undefined') {
          setTimeout(function () {
            // stored.betTypeStakes.PerTab = {}
            Vue.set(context.state, 'betTypeStakes', stored.betTypeStakes)
            context.state.interRelated = interRelatedService.checkInterRelated(context.state.betslipSelections, context.state.markets)
          }, 1000)
        }
      }
      context.dispatch('initBetSlipUpdate', 0.1)
      // context.dispatch('scheduleBetSlipUpdate')
    }
  },
  clearStoredBetSlip () {
    // console.log('clearStoredBetSlip')
    var storage = localStorage
    storage.removeItem('BSstate')
  },

  fetchBettingParams: fetchParams.fetchBettingParams,
  fetchBetSlipParams: fetchParams.fetchBetSlipParams,
  fetchCoreParams: fetchParams.fetchCoreParams,

  betSlipChecks: actionsBetSlipChecks.betSlipChecks,

  initBetSlipUpdate: actionsUpdate.initBetSlipUpdate,
  stopBetSlipUpdate: actionsUpdate.stopBetSlipUpdate,
  scheduleBetSlipUpdate: actionsUpdate.scheduleBetSlipUpdate,
  checkForBetSlipUpdate: actionsUpdate.checkForBetSlipUpdate,
  updateBetSlip: actionsUpdate.updateBetSlip,
  updateBetSlipSelections: actionsUpdate.updateBetSlipSelections,
  updateSingleBetSlip: actionsUpdate.updateSingleBetSlip,
  updateStoredBetSlipSelections: actionsUpdate.updateStoredBetSlipSelections,
  setBetSlipChange: actionsUpdate.setBetSlipChange,
  resetBetSlipChanges: actionsUpdate.resetBetSlipChanges,
  removeClosedOrSuspended: actionsUpdate.removeClosedOrSuspended,

  getTeaserOptions: actionsTeasers.getTeaserOptions,
  getTeaser: actionsTeasers.getTeaser,
  getTeasers: actionsTeasers.getTeasers,
  getAllowedBetTypesAndReturns4Teasers: actionsTeasers.getAllowedBetTypesAndReturns4Teasers,
  updateTeaser: actionsTeasers.updateTeaser,
  getTeaserGroups: actionsTeasers.getTeaserGroups,

  injectselections: addMultiSelections.injectselections,
  fetchMultipleSelections: addMultiSelections.fetchMultipleSelections
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/sports/betslip/index.js